export default "__VITE_ASSET__e9844f11__"